module.exports = __webpack_public_path__ + "img/screenshot_example_01.2decb0ac.png";